import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomSearchInputComponent } from './custom-search-input.component'
import { FormsModule } from '@angular/forms'

@NgModule({
  declarations: [CustomSearchInputComponent],
  exports: [CustomSearchInputComponent],
  imports: [CommonModule, FormsModule]
})
export class CustomSearchInputModule {}
